import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import { connect } from "react-redux";
import quicklink from "quicklink/dist/quicklink.mjs";
import { setOverlayValue } from "store";

import api from "api";
import Builder from "partials/Builder";
import { redirect404, checkResourcePath } from "helpers";
import HeadMeta from "partials/HeadMeta";
import Footer from "partials/Footer";
import ErrorBoundary from "partials/ErrorBoundary";
import CookieNotice from "partials/CookieNotice";

import Media from "css/Media";

import { setCurrentView, setImageGallery } from "store";

class Page extends Component {
  componentDidMount() {
    this.mounted = true;
    this._loadPageData();
    this.props.setOverlayValue({ visible: false });
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this._loadPageData();
    } else {
      if (!this.mounted) {
        this.props.setOverlayValue({ visible: false });
      } else if (prevProps.page !== this.props.page) {
        this.scrapeForImages();
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  _loadPageData() {
    window.scrollTo(0, 0);
    this.props.setCurrentView(null);

    api.pageFetcher
      .getBySlug({
        slug: this.props.match.params.slug
          ? this.props.match.params.slug
          : this.props.location.pathname,
      })
      .then((resp) => {
        const page = resp.data[0];
        if (page && page.id) {
          if (!api.pageFetcher.middleware.requestingPagePreview()) {
            // checkResourcePath() will redirect to 404 if resource.link !== location.pathname
            if (!checkResourcePath(page, this.props.location)) return;
          }
          this.props.setCurrentView(page);
          quicklink();
        } else {
          redirect404();
        }
      });
  }

  scrapeForImages() {
    let page = (this.props.page && this.props.page.acf) || null;

    if (page && page.modules) {
      let arr = [];

      if (page.featured_image && page.featured_image.length) {
        arr.push({ image: page.featured_image });
      }

      let twoImagesArr = page.modules.filter(
        (module) => module.acf_fc_layout === "two_images"
      );
      if (twoImagesArr.length) {
        twoImagesArr.map((module) => {
          arr.push({ image: module.image_one });
          arr.push({ image: module.image_two });
          return null;
        });
      }

      let imageModuleArr = page.modules.filter(
        (module) => module.acf_fc_layout === "image"
      );
      if (imageModuleArr.length) {
        imageModuleArr.map((module) => {
          arr.push({ image: module.image });
          return null;
        });
      }

      this.props.setImageGallery(arr);
    }
  }

  render() {
    const { page } = this.props;

    return <PageMarkup page={page} />;
  }
}

export const PageMarkup = (props) => {
  const { page } = props;
  if (!page) return null;
  return (
    <Wrapper>
      <HeadMeta page={page} />
      <Modules>
        <ErrorBoundary for="Page builder">
          <Builder data={page.acf.modules} page={page} />
        </ErrorBoundary>
      </Modules>
      {(page.content || page.post_content) && (
        <div
          dangerouslySetInnerHTML={{
            __html: page.content ? page.content.rendered : page.post_content,
          }}
        />
      )}
      <ErrorBoundary for="Footer">
        <Footer />
      </ErrorBoundary>
      <CookieNotice />
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    page: state.currentView,
    overlayValue: state.overlayValue,
    imageGallery: state.imageGallery,
  };
};

const actions = {
  setCurrentView,
  setOverlayValue,
  setImageGallery,
};

export default connect(mapStateToProps, actions)(withRouter(Page));

const Wrapper = styled.div`
  display: block;
  position: relative;
  width: 100%;
`;

const Modules = styled.article`
  padding: 160px 0 90px;

  ${Media.greaterThan("s")`
        padding: 220px 0 120px;
    `}

  ${Media.greaterThan("m")`
        padding: 260px 0 160px;
    `}
`;
